// Jedna instance codebook selektoru / kategorie → stabilní query key.

import { createCodebookSelector } from '@/modules/codebooks';

export const vehicleCategorySelector = createCodebookSelector('VehicleCategory');
export const vehicleGroupSelector = createCodebookSelector('VehicleGroup');
export const vehicleManufacturerSelector = createCodebookSelector('VehicleManufacturer');
export const vehicleDocumentTypeSelector = createCodebookSelector('VehicleDocumentType');
export const serviceEventTypeSelector = createCodebookSelector('ServiceEventType');
